import React from "react";
import styles from "./Sidebar.module.scss";
import { Link, NavLink, useLocation } from "react-router-dom";

// img
import logo from "../../../Assets/images/logo.png";
import { Accordion, Button } from "react-bootstrap";
import { GiMeal, GiKiwiFruit } from "react-icons/gi";
import { MdFoodBank } from "react-icons/md";
import { FaBookOpen } from "react-icons/fa6";
import { PiBowlFoodFill } from "react-icons/pi";
import { TbFileText, TbLogs, TbMessageCircle } from "react-icons/tb";
import { useSelector } from "react-redux";
import { BiCategory } from "react-icons/bi";
import { FiPackage } from "react-icons/fi";
import { IoSettingsOutline } from "react-icons/io5";

const Sidebar = ({ sidebar, setSidebar }) => {
  const location = useLocation();
  const pageActive = location.pathname;
  const handleSidebar = () => {
    setSidebar(!sidebar);
  };

  const { user } = useSelector((state) => state.auth);

  return (
    <div
      className={`${styles.sidebar} ${sidebar && styles.active
        } pt-4 position-fixed`}
    >
      <Button
        onClick={handleSidebar}
        variant="transparent"
        className="position-absolute border-0 p-2 closeBtn d-lg-none"
        style={{ top: 0, right: 0 }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="15"
          height="21"
          viewBox="0 0 15 21"
          fill="none"
        >
          <path
            d="M7.245 6.529L10.668 1.3H14.259V1.447L9.303 8.608L14.343 15.895V16H10.71L7.245 10.834L3.78 16H0.147V15.895L5.145 8.608L0.21 1.447V1.3H3.801L7.245 6.529Z"
            fill="white"
          />
        </svg>
      </Button>
      <div className={`${styles.top} top text-center px-3 py-2`}>
        <Link to="/" className={`${styles.logo} logo`}>
          <img src={logo} alt="" className="img-fluid" />
        </Link>
      </div>
      <Accordion className={`${styles.linkWrpper} linkWrpper pt-2 px-2`}>
        {user?.role == "Admin" && (
          <ul className="list-unstyled ps-0 mb-0">
            <li className="py-1">
              <NavLink
                to="/dashboard"
                className={`${styles.link} ${pageActive.includes("/dashboard") && styles.active
                  } d-flex align-items-center gap-10 text-white`}
              >
                <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    viewBox="0 0 18 19"
                    fill="none"
                  >
                    <path
                      d="M6.93746 0.196777H1.31246C0.588731 0.196777 0 0.785508 0 1.50923V4.88424C0 5.6081 0.588731 6.19683 1.31246 6.19683H6.93746C7.66133 6.19683 8.25006 5.6081 8.25006 4.88424V1.50923C8.25006 0.785508 7.66133 0.196777 6.93746 0.196777Z"
                      fill="white"
                    />
                    <path
                      d="M6.93746 7.69678H1.31246C0.588731 7.69678 0 8.28551 0 9.00937V16.8844C0 17.6081 0.588731 18.1968 1.31246 18.1968H6.93746C7.66133 18.1968 8.25006 17.6081 8.25006 16.8844V9.00937C8.25006 8.28551 7.66133 7.69678 6.93746 7.69678Z"
                      fill="white"
                    />
                    <path
                      d="M16.6876 12.1968H11.0626C10.3387 12.1968 9.75 12.7855 9.75 13.5094V16.8844C9.75 17.6081 10.3387 18.1968 11.0626 18.1968H16.6876C17.4113 18.1968 18.0001 17.6081 18.0001 16.8844V13.5094C18.0001 12.7855 17.4113 12.1968 16.6876 12.1968Z"
                      fill="white"
                    />
                    <path
                      d="M16.6876 0.196777H11.0626C10.3387 0.196777 9.75 0.785508 9.75 1.50923V9.38425C9.75 10.1081 10.3387 10.6968 11.0626 10.6968H16.6876C17.4113 10.6968 18.0001 10.1081 18.0001 9.38425V1.50923C18.0001 0.785508 17.4113 0.196777 16.6876 0.196777Z"
                      fill="white"
                    />
                  </svg>
                </span>
                Dashboard
              </NavLink>
            </li>

            <li className="py-1">
              <NavLink
                to="/manage-user"
                className={`${styles.link} ${pageActive.includes("/manage-user") && styles.active
                  } d-flex align-items-center gap-10 text-white`}
              >
                <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    viewBox="0 0 18 16"
                    fill="none"
                  >
                    <path
                      d="M10.8622 2.63264C11.6945 3.15447 12.2781 4.03751 12.3844 5.06252C12.7238 5.22111 13.1005 5.31231 13.4999 5.31231C14.958 5.31231 16.1398 4.13051 16.1398 2.67263C16.1398 1.21452 14.958 0.0327148 13.4999 0.0327148C12.0557 0.0331641 10.8842 1.19385 10.8622 2.63264ZM9.13276 8.03781C10.5909 8.03781 11.7727 6.85578 11.7727 5.3979C11.7727 3.94002 10.5906 2.75821 9.13276 2.75821C7.67488 2.75821 6.4924 3.94024 6.4924 5.39812C6.4924 6.856 7.67488 8.03781 9.13276 8.03781ZM10.2526 8.21774H8.0125C6.14871 8.21774 4.63242 9.73425 4.63242 11.598V14.3375L4.63939 14.3804L4.82808 14.4395C6.60674 14.9952 8.152 15.1805 9.42389 15.1805C11.9081 15.1805 13.348 14.4723 13.4368 14.4271L13.6131 14.3379H13.632V11.598C13.6326 9.73425 12.1164 8.21774 10.2526 8.21774ZM14.6201 5.49247H12.3974C12.3733 6.3818 11.9937 7.18262 11.3933 7.75859C13.0499 8.25121 14.2621 9.78749 14.2621 11.6021V12.4463C16.4568 12.3659 17.7215 11.7438 17.8048 11.7021L17.9811 11.6126H18V8.87233C18 7.00875 16.4837 5.49247 14.6201 5.49247ZM4.50056 5.31276C5.017 5.31276 5.49749 5.16203 5.90453 4.90527C6.03392 4.06132 6.48634 3.32384 7.13261 2.82156C7.13531 2.77214 7.14002 2.72317 7.14002 2.6733C7.14002 1.21519 5.95799 0.0333887 4.50056 0.0333887C3.04223 0.0333887 1.86065 1.21519 1.86065 2.6733C1.86065 4.13073 3.04223 5.31276 4.50056 5.31276ZM6.87136 7.75859C6.27383 7.18554 5.89555 6.38899 5.86791 5.50505C5.78547 5.49898 5.70393 5.49247 5.61992 5.49247H3.38008C1.51629 5.49247 0 7.00875 0 8.87233V11.6122L0.00696368 11.6544L0.195657 11.714C1.62254 12.1594 2.89599 12.3647 4.0021 12.4294V11.6021C4.00255 9.78749 5.21423 8.25166 6.87136 7.75859Z"
                      fill="white"
                    />
                  </svg>
                </span>
                Customers
              </NavLink>
            </li>

            <li className="py-1">
              <NavLink
                to="/orders"
                className={`${styles.link} ${pageActive === ("/orders") && styles.active
                  } d-flex align-items-center gap-10 text-white`}
              >
                <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    viewBox="0 0 14 19"
                    fill="none"
                  >
                    <path
                      d="M4.03866 5.771C3.69219 5.771 3.41797 6.04521 3.41797 6.39169V7.6658C4.09377 7.79262 4.66011 8.41016 4.65995 9.18418C4.6598 9.95235 4.104 10.5706 3.41797 10.7074V11.9791C3.41797 12.3256 3.69219 12.6004 4.03866 12.6004H12.7289C13.0754 12.6004 13.3496 12.3256 13.3496 11.9791V10.7074C12.6636 10.5706 12.1078 9.95235 12.1076 9.18418C12.1075 8.41016 12.6738 7.79262 13.3496 7.6658V6.39169C13.3496 6.04521 13.0754 5.771 12.7289 5.771H4.03866ZM6.83176 6.39169C7.51368 6.39169 8.07375 6.95115 8.07375 7.63306C8.07375 8.31498 7.51368 8.87505 6.83176 8.87505C6.14984 8.87505 5.58978 8.31498 5.58978 7.63306C5.58978 6.95115 6.14984 6.39169 6.83176 6.39169ZM10.3589 6.90145C10.438 6.90145 10.5172 6.93161 10.5777 6.99177C10.698 7.11281 10.698 7.30836 10.5777 7.4294L6.6281 11.379C6.50679 11.5009 6.30935 11.5009 6.18804 11.379C6.06772 11.258 6.06772 11.0624 6.18804 10.9414L10.1401 6.99177C10.2006 6.93161 10.2798 6.90145 10.3589 6.90145ZM6.83176 7.01238C6.48529 7.01238 6.21107 7.28659 6.21107 7.63306C6.21107 7.97954 6.48529 8.25436 6.83176 8.25436C7.17823 8.25436 7.45245 7.97954 7.45245 7.63306C7.45245 7.28659 7.17823 7.01238 6.83176 7.01238ZM9.93582 9.49574C10.6177 9.49574 11.1778 10.0558 11.1778 10.7377C11.1778 11.4196 10.6177 11.9791 9.93582 11.9791C9.2539 11.9791 8.69444 11.4196 8.69444 10.7377C8.69444 10.0558 9.2539 9.49574 9.93582 9.49574ZM9.93582 10.117C9.58934 10.117 9.31513 10.3913 9.31513 10.7377C9.31513 11.0842 9.58934 11.3584 9.93582 11.3584C10.2823 11.3584 10.5571 11.0842 10.5571 10.7377C10.5571 10.3913 10.2823 10.117 9.93582 10.117Z"
                      fill="white"
                    />
                    <path
                      d="M1.48646 0.494629C0.968591 0.494629 0.556641 0.90961 0.556641 1.42748V17.5648C0.55664 18.0827 0.968591 18.4946 1.48646 18.4946H10.4877C11.0055 18.4946 11.4181 18.0827 11.4181 17.5648V13.2212C9.11846 13.2209 4.59052 13.2212 4.59052 13.2212C3.9086 13.2212 3.34914 12.6611 3.34914 11.9792V10.4263C3.34974 10.2548 3.48924 10.1165 3.6607 10.1171C4.17857 10.1171 4.59052 9.70216 4.59052 9.18428C4.59052 8.66641 4.17857 8.25446 3.6607 8.25446C3.48924 8.25512 3.34976 8.11678 3.34914 7.94533V6.39179C3.34914 5.70987 3.9086 5.1498 4.59052 5.1498H11.4181V1.42748C11.4181 0.909611 11.0055 0.494629 10.4877 0.494629H1.48646ZM5.80886 1.42748C5.8168 1.42728 5.82453 1.42748 5.8325 1.42748C6.34302 1.42748 6.76293 1.84678 6.76293 2.3573C6.76293 2.86782 6.34302 3.29016 5.8325 3.29016C5.32198 3.29016 4.90026 2.86782 4.90026 2.3573C4.90026 1.85476 5.30913 1.44031 5.80886 1.42748ZM5.8325 2.04817C5.65743 2.04817 5.52095 2.18223 5.52095 2.3573C5.52095 2.53238 5.65743 2.66886 5.8325 2.66886C6.00758 2.66886 6.14164 2.53238 6.14164 2.3573C6.14164 2.18223 6.00758 2.04817 5.8325 2.04817ZM5.21181 15.7021H6.4538C6.96432 15.7021 7.38362 16.1239 7.38362 16.6344C7.38362 17.1449 6.96432 17.5648 6.4538 17.5648H5.21181C4.70129 17.5648 4.27957 17.1449 4.27957 16.6344C4.27957 16.1239 4.70129 15.7021 5.21181 15.7021ZM5.21181 16.3228C5.03674 16.3228 4.90026 16.4593 4.90026 16.6344C4.90026 16.8095 5.03674 16.9435 5.21181 16.9435H6.4538C6.62887 16.9435 6.76293 16.8095 6.76293 16.6344C6.76293 16.4593 6.62887 16.3228 6.4538 16.3228H5.21181Z"
                      fill="white"
                    />
                  </svg>
                </span>
                Orders Management Today
              </NavLink>
            </li>

            <li className="py-1">
              <NavLink
                to="/order-manage"
                className={`${styles.link} ${pageActive.includes("/order-manage") && styles.active
                  } d-flex align-items-center gap-10 text-white`}
              >
                <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                  <PiBowlFoodFill size={"1.5em"} />
                </span>
                Order Management Group
              </NavLink>
            </li>

            <li className="py-1">
              <Accordion.Item
                className={`${styles.accordionWrp} border-0 bg-transparent`}
                eventKey="1"
              >
                <Accordion.Header
                  className={`${styles.accordionBtn} fw-bold d-flex align-items-center gap-10`}
                >
                  <span className={`${styles.icn} ${styles.fill} icn me-1`}>
                    <MdFoodBank size="1.5em" />
                  </span>
                  Manage Ingredients
                </Accordion.Header>
                <Accordion.Body className="pb-0 pt-2 pe-0">
                  <ul className="list-unstyled ps-3 mb-0">
                    <li className="py-1">
                      <NavLink
                        to="/manage-category"
                        className={`${styles.link} ${pageActive.includes("/manage-category") &&
                          styles.active
                          } d-flex align-items-center gap-10 text-white`}
                      >
                        {/* <FaBookOpen /> */}
                        Category
                      </NavLink>
                    </li>

                    <li className="py-1">
                      <NavLink
                        to="/diet-type"
                        className={`${styles.link} ${pageActive.includes("/diet-type") && styles.active
                          } d-flex align-items-center gap-10 text-white`}
                      >
                        {/* <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                          <GiMeal size="1.5em" />
                        </span> */}
                        Diet Type
                      </NavLink>
                    </li>

                    <li className="py-1">
                      <NavLink
                        to="/equipment"
                        className={`${styles.link} ${pageActive.includes("/equipment") && styles.active
                          } d-flex align-items-center gap-10 text-white`}
                      >
                        {/* <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                          <MdFoodBank size="1.5em" />
                        </span> */}
                        Equipments
                      </NavLink>
                    </li>

                    <li className="py-1">
                      <NavLink
                        to="/ingredient-management"
                        className={`${styles.link} ${pageActive.includes("/ingredient-management") &&
                          styles.active
                          } d-flex align-items-center gap-10 text-white`}
                      >
                        {/* <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                          <MdFoodBank size="1.5em" />
                        </span> */}
                        Ingredients
                      </NavLink>
                    </li>

                    <li className="py-1">
                      <NavLink
                        to="/meal-package-management"
                        className={`${styles.link} ${pageActive.includes("/meal-package-management") &&
                          styles.active
                          } d-flex align-items-center gap-10 text-white`}
                      >
                        {/* <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                          <GiMeal size="1.5em" />
                        </span> */}
                        Meal Packages
                      </NavLink>
                    </li>

                    <li className="py-1">
                      <NavLink
                        to="/recipes"
                        className={`${styles.link} ${pageActive.includes("/recipes") && styles.active
                          } d-flex align-items-center gap-10 text-white`}
                      >
                        {/* <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                          <PiBowlFoodFill size={"1.5em"} />
                        </span> */}
                        Recipes
                      </NavLink>
                    </li>
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
            </li>
            {/* Store Order Management Link */}
            <li className="py-1">
              <NavLink
                to="/store-order-management"
                className={`${styles.link} ${pageActive === "/store-order-management" && styles.active
                  } d-flex align-items-center gap-10 text-white`}
              >
                <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M4 4H16V16H4V4Z"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M8 8H12V12H8V8Z"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                Store Order Management
              </NavLink>
            </li>
            <li className="py-1">
              <NavLink
                to="/store-order-management-today"
                className={`${styles.link} ${pageActive === "/store-order-management-today" &&
                  styles.active
                  } d-flex align-items-center gap-10 text-white`}
              >
                <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <circle
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="white"
                      strokeWidth="2"
                    />
                    <path
                      d="M12 6v6l4 2"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                Store Order Management Today
              </NavLink>
            </li>

            {/* {"Store Management"} */}
            <li className="py-1">
              <Accordion.Item
                className={`${styles.accordionWrp} border-0 bg-transparent`}
                eventKey="2"
              >
                <Accordion.Header
                  className={`${styles.accordionBtn} fw-bold d-flex align-items-center gap-10`}
                >
                  <span className={`${styles.icn} ${styles.fill} icn me-1`}>
                    <MdFoodBank size="1.5em" />
                  </span>
                  Manage Store
                </Accordion.Header>
                <Accordion.Body className="pb-0 pt-2 pe-0">
                  <ul className="list-unstyled ps-3 mb-0">
                    <li className="py-1">
                      <NavLink
                        to="/product"
                        className={`${styles.link} ${pageActive === "/product" && styles.active
                          } d-flex align-items-center gap-10 text-white`}
                      >
                        <span
                          className={`${styles.icn} ${styles.stroke} icn me-1`}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="15"
                            height="15"
                            viewBox="0 0 20 21"
                            fill="none"
                          >
                            <path
                              d="M12.9297 0.873535C10.3445 0.873535 8.24219 3.01545 8.24219 5.6001C8.24219 8.18475 10.3445 10.2876 12.9297 10.2876C15.5149 10.2876 17.6172 8.18475 17.6172 5.6001C17.6172 3.01545 15.5149 0.873535 12.9297 0.873535ZM11.7578 3.25635C12.0814 3.25635 12.3438 3.51861 12.3438 3.84229C12.3438 4.16588 12.0814 4.42822 11.7578 4.42822C11.4342 4.42822 11.1719 4.16588 11.1719 3.84229C11.1719 3.51861 11.4343 3.25635 11.7578 3.25635ZM14.1016 7.94385C13.778 7.94385 13.5156 7.6815 13.5156 7.35791C13.5156 7.03424 13.778 6.77197 14.1016 6.77197C14.4252 6.77197 14.6875 7.03424 14.6875 7.35791C14.6875 7.6815 14.4252 7.94385 14.1016 7.94385ZM14.5891 4.16729L12.2454 7.68291C12.0638 7.95436 11.6999 8.02346 11.4328 7.84541C11.1639 7.66572 11.0906 7.3024 11.2703 7.03287L13.6141 3.51725C13.7949 3.24717 14.1588 3.17623 14.4266 3.35475C14.6955 3.53443 14.7688 3.89779 14.5891 4.16729Z"
                              fill="white"
                            />
                            <path
                              d="M0.171621 15.7327C-0.057207 15.9616 -0.057207 16.3325 0.171621 16.5613L4.27318 20.7019C4.50205 20.9308 4.87287 20.9308 5.10174 20.7019L5.93049 19.8731C6.15936 19.6443 6.15936 19.2733 5.93049 19.0444L1.82908 14.9039C1.60021 14.675 1.22928 14.675 1.00037 14.9039L0.171621 15.7327Z"
                              fill="white"
                            />
                            <path
                              d="M15.3638 17.1977L19.8168 13.0433C20.058 12.814 20.0599 12.4338 19.8282 12.2033C19.8241 12.1991 19.82 12.195 19.8158 12.191C19.1746 11.5589 18.0791 11.6201 17.4036 12.2153L14.8801 14.4875C14.5734 14.7937 14.1339 14.975 13.667 14.975H9.99988C9.67602 14.975 9.41395 14.713 9.41395 14.3891C9.41395 14.0652 9.67602 13.8032 9.99988 13.8032H13.5155C14.1627 13.8032 14.6874 13.2784 14.6874 12.6313C14.6874 11.9841 14.1627 11.4594 13.5155 11.4594H11.1054C9.84652 10.0558 7.41453 9.94309 6.0332 11.246L2.84082 14.2591L6.58734 18.0441L7.27375 17.3579H14.9611C15.1108 17.3579 15.255 17.3005 15.3638 17.1977Z"
                              fill="white"
                            />
                          </svg>
                        </span>
                        Product Management
                      </NavLink>
                    </li>

                    <li className="py-1">
                      <NavLink
                        to="/categoryManagement"
                        className={`${styles.link} ${pageActive.includes("/categoryManagement") &&
                          styles.active
                          } d-flex align-items-center gap-10 text-white`}
                      >
                        <span
                          className={`${styles.icn} ${styles.stroke} icn me-1`}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="15"
                            height="15"
                            viewBox="0 0 20 21"
                            fill="none"
                          >
                            <path
                              d="M12.9297 0.873535C10.3445 0.873535 8.24219 3.01545 8.24219 5.6001C8.24219 8.18475 10.3445 10.2876 12.9297 10.2876C15.5149 10.2876 17.6172 8.18475 17.6172 5.6001C17.6172 3.01545 15.5149 0.873535 12.9297 0.873535ZM11.7578 3.25635C12.0814 3.25635 12.3438 3.51861 12.3438 3.84229C12.3438 4.16588 12.0814 4.42822 11.7578 4.42822C11.4342 4.42822 11.1719 4.16588 11.1719 3.84229C11.1719 3.51861 11.4343 3.25635 11.7578 3.25635ZM14.1016 7.94385C13.778 7.94385 13.5156 7.6815 13.5156 7.35791C13.5156 7.03424 13.778 6.77197 14.1016 6.77197C14.4252 6.77197 14.6875 7.03424 14.6875 7.35791C14.6875 7.6815 14.4252 7.94385 14.1016 7.94385ZM14.5891 4.16729L12.2454 7.68291C12.0638 7.95436 11.6999 8.02346 11.4328 7.84541C11.1639 7.66572 11.0906 7.3024 11.2703 7.03287L13.6141 3.51725C13.7949 3.24717 14.1588 3.17623 14.4266 3.35475C14.6955 3.53443 14.7688 3.89779 14.5891 4.16729Z"
                              fill="white"
                            />
                            <path
                              d="M0.171621 15.7327C-0.057207 15.9616 -0.057207 16.3325 0.171621 16.5613L4.27318 20.7019C4.50205 20.9308 4.87287 20.9308 5.10174 20.7019L5.93049 19.8731C6.15936 19.6443 6.15936 19.2733 5.93049 19.0444L1.82908 14.9039C1.60021 14.675 1.22928 14.675 1.00037 14.9039L0.171621 15.7327Z"
                              fill="white"
                            />
                            <path
                              d="M15.3638 17.1977L19.8168 13.0433C20.058 12.814 20.0599 12.4338 19.8282 12.2033C19.8241 12.1991 19.82 12.195 19.8158 12.191C19.1746 11.5589 18.0791 11.6201 17.4036 12.2153L14.8801 14.4875C14.5734 14.7937 14.1339 14.975 13.667 14.975H9.99988C9.67602 14.975 9.41395 14.713 9.41395 14.3891C9.41395 14.0652 9.67602 13.8032 9.99988 13.8032H13.5155C14.1627 13.8032 14.6874 13.2784 14.6874 12.6313C14.6874 11.9841 14.1627 11.4594 13.5155 11.4594H11.1054C9.84652 10.0558 7.41453 9.94309 6.0332 11.246L2.84082 14.2591L6.58734 18.0441L7.27375 17.3579H14.9611C15.1108 17.3579 15.255 17.3005 15.3638 17.1977Z"
                              fill="white"
                            />
                          </svg>
                        </span>
                        Product Category
                      </NavLink>
                    </li>
                    <li className="py-1">
                      <NavLink
                        to="/products-settings"
                        className={`${styles.link} ${pageActive === "/products-settings" && styles.active
                          } d-flex align-items-center gap-10 text-white`}
                      >
                        <span
                          className={`${styles.icn} ${styles.fill} icn me-1`}
                        >
                          <IoSettingsOutline size="1.5em" />
                        </span>
                        Products Settings
                      </NavLink>
                    </li>
                    <li className="py-1">
                      <NavLink
                        to="/manage-dietary"
                        className={`${styles.link} ${pageActive.includes("/manage-dietary") &&
                          styles.active
                          } d-flex align-items-center gap-10 text-white`}
                      >
                        <span
                          className={`${styles.icn} ${styles.fill} icn me-1`}
                        >
                          <GiKiwiFruit size="1.5em" />
                        </span>
                        Manage Dietary Preferences
                      </NavLink>
                    </li>
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
            </li>

            <li className="py-1">
              <NavLink
                to="/promocode"
                className={`${styles.link} ${pageActive.includes("/promocode") && styles.active
                  } d-flex align-items-center gap-10 text-white`}
              >
                <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    viewBox="0 0 14 19"
                    fill="none"
                  >
                    <path
                      d="M4.03866 5.771C3.69219 5.771 3.41797 6.04521 3.41797 6.39169V7.6658C4.09377 7.79262 4.66011 8.41016 4.65995 9.18418C4.6598 9.95235 4.104 10.5706 3.41797 10.7074V11.9791C3.41797 12.3256 3.69219 12.6004 4.03866 12.6004H12.7289C13.0754 12.6004 13.3496 12.3256 13.3496 11.9791V10.7074C12.6636 10.5706 12.1078 9.95235 12.1076 9.18418C12.1075 8.41016 12.6738 7.79262 13.3496 7.6658V6.39169C13.3496 6.04521 13.0754 5.771 12.7289 5.771H4.03866ZM6.83176 6.39169C7.51368 6.39169 8.07375 6.95115 8.07375 7.63306C8.07375 8.31498 7.51368 8.87505 6.83176 8.87505C6.14984 8.87505 5.58978 8.31498 5.58978 7.63306C5.58978 6.95115 6.14984 6.39169 6.83176 6.39169ZM10.3589 6.90145C10.438 6.90145 10.5172 6.93161 10.5777 6.99177C10.698 7.11281 10.698 7.30836 10.5777 7.4294L6.6281 11.379C6.50679 11.5009 6.30935 11.5009 6.18804 11.379C6.06772 11.258 6.06772 11.0624 6.18804 10.9414L10.1401 6.99177C10.2006 6.93161 10.2798 6.90145 10.3589 6.90145ZM6.83176 7.01238C6.48529 7.01238 6.21107 7.28659 6.21107 7.63306C6.21107 7.97954 6.48529 8.25436 6.83176 8.25436C7.17823 8.25436 7.45245 7.97954 7.45245 7.63306C7.45245 7.28659 7.17823 7.01238 6.83176 7.01238ZM9.93582 9.49574C10.6177 9.49574 11.1778 10.0558 11.1778 10.7377C11.1778 11.4196 10.6177 11.9791 9.93582 11.9791C9.2539 11.9791 8.69444 11.4196 8.69444 10.7377C8.69444 10.0558 9.2539 9.49574 9.93582 9.49574ZM9.93582 10.117C9.58934 10.117 9.31513 10.3913 9.31513 10.7377C9.31513 11.0842 9.58934 11.3584 9.93582 11.3584C10.2823 11.3584 10.5571 11.0842 10.5571 10.7377C10.5571 10.3913 10.2823 10.117 9.93582 10.117Z"
                      fill="white"
                    />
                    <path
                      d="M1.48646 0.494629C0.968591 0.494629 0.556641 0.90961 0.556641 1.42748V17.5648C0.55664 18.0827 0.968591 18.4946 1.48646 18.4946H10.4877C11.0055 18.4946 11.4181 18.0827 11.4181 17.5648V13.2212C9.11846 13.2209 4.59052 13.2212 4.59052 13.2212C3.9086 13.2212 3.34914 12.6611 3.34914 11.9792V10.4263C3.34974 10.2548 3.48924 10.1165 3.6607 10.1171C4.17857 10.1171 4.59052 9.70216 4.59052 9.18428C4.59052 8.66641 4.17857 8.25446 3.6607 8.25446C3.48924 8.25512 3.34976 8.11678 3.34914 7.94533V6.39179C3.34914 5.70987 3.9086 5.1498 4.59052 5.1498H11.4181V1.42748C11.4181 0.909611 11.0055 0.494629 10.4877 0.494629H1.48646ZM5.80886 1.42748C5.8168 1.42728 5.82453 1.42748 5.8325 1.42748C6.34302 1.42748 6.76293 1.84678 6.76293 2.3573C6.76293 2.86782 6.34302 3.29016 5.8325 3.29016C5.32198 3.29016 4.90026 2.86782 4.90026 2.3573C4.90026 1.85476 5.30913 1.44031 5.80886 1.42748ZM5.8325 2.04817C5.65743 2.04817 5.52095 2.18223 5.52095 2.3573C5.52095 2.53238 5.65743 2.66886 5.8325 2.66886C6.00758 2.66886 6.14164 2.53238 6.14164 2.3573C6.14164 2.18223 6.00758 2.04817 5.8325 2.04817ZM5.21181 15.7021H6.4538C6.96432 15.7021 7.38362 16.1239 7.38362 16.6344C7.38362 17.1449 6.96432 17.5648 6.4538 17.5648H5.21181C4.70129 17.5648 4.27957 17.1449 4.27957 16.6344C4.27957 16.1239 4.70129 15.7021 5.21181 15.7021ZM5.21181 16.3228C5.03674 16.3228 4.90026 16.4593 4.90026 16.6344C4.90026 16.8095 5.03674 16.9435 5.21181 16.9435H6.4538C6.62887 16.9435 6.76293 16.8095 6.76293 16.6344C6.76293 16.4593 6.62887 16.3228 6.4538 16.3228H5.21181Z"
                      fill="white"
                    />
                  </svg>
                </span>
                Promo Codes
              </NavLink>
            </li>

            <li className="py-1">
              <NavLink
                to="/reviews"
                className={`${styles.link} ${pageActive.includes("/reviews") && styles.active
                  } d-flex align-items-center gap-10 text-white`}
              >
                <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    viewBox="0 0 20 21"
                    fill="none"
                  >
                    <path
                      d="M12.9297 0.873535C10.3445 0.873535 8.24219 3.01545 8.24219 5.6001C8.24219 8.18475 10.3445 10.2876 12.9297 10.2876C15.5149 10.2876 17.6172 8.18475 17.6172 5.6001C17.6172 3.01545 15.5149 0.873535 12.9297 0.873535ZM11.7578 3.25635C12.0814 3.25635 12.3438 3.51861 12.3438 3.84229C12.3438 4.16588 12.0814 4.42822 11.7578 4.42822C11.4342 4.42822 11.1719 4.16588 11.1719 3.84229C11.1719 3.51861 11.4343 3.25635 11.7578 3.25635ZM14.1016 7.94385C13.778 7.94385 13.5156 7.6815 13.5156 7.35791C13.5156 7.03424 13.778 6.77197 14.1016 6.77197C14.4252 6.77197 14.6875 7.03424 14.6875 7.35791C14.6875 7.6815 14.4252 7.94385 14.1016 7.94385ZM14.5891 4.16729L12.2454 7.68291C12.0638 7.95436 11.6999 8.02346 11.4328 7.84541C11.1639 7.66572 11.0906 7.3024 11.2703 7.03287L13.6141 3.51725C13.7949 3.24717 14.1588 3.17623 14.4266 3.35475C14.6955 3.53443 14.7688 3.89779 14.5891 4.16729Z"
                      fill="white"
                    />
                    <path
                      d="M0.171621 15.7327C-0.057207 15.9616 -0.057207 16.3325 0.171621 16.5613L4.27318 20.7019C4.50205 20.9308 4.87287 20.9308 5.10174 20.7019L5.93049 19.8731C6.15936 19.6443 6.15936 19.2733 5.93049 19.0444L1.82908 14.9039C1.60021 14.675 1.22928 14.675 1.00037 14.9039L0.171621 15.7327Z"
                      fill="white"
                    />
                    <path
                      d="M15.3638 17.1977L19.8168 13.0433C20.058 12.814 20.0599 12.4338 19.8282 12.2033C19.8241 12.1991 19.82 12.195 19.8158 12.191C19.1746 11.5589 18.0791 11.6201 17.4036 12.2153L14.8801 14.4875C14.5734 14.7937 14.1339 14.975 13.667 14.975H9.99988C9.67602 14.975 9.41395 14.713 9.41395 14.3891C9.41395 14.0652 9.67602 13.8032 9.99988 13.8032H13.5155C14.1627 13.8032 14.6874 13.2784 14.6874 12.6313C14.6874 11.9841 14.1627 11.4594 13.5155 11.4594H11.1054C9.84652 10.0558 7.41453 9.94309 6.0332 11.246L2.84082 14.2591L6.58734 18.0441L7.27375 17.3579H14.9611C15.1108 17.3579 15.255 17.3005 15.3638 17.1977Z"
                      fill="white"
                    />
                  </svg>
                </span>
                Reviews
              </NavLink>
            </li>

            <li className="py-1">
              <NavLink
                to="/manage-store-review"
                className={`${styles.link} ${pageActive.includes("/manage-store-review") && styles.active
                  } d-flex align-items-center gap-10 text-white`}
              >
                <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M10 15.27L16.18 19l-1.64-7.03L20 7.24l-7.19-.61L10 0 7.19 6.63 0 7.24l5.46 4.73L3.82 19z"
                      fill="white"
                    />
                  </svg>
                </span>
                Online Store Reviews
              </NavLink>
            </li>

            <li className="py-1">
              <NavLink
                to="/refund-transaction"
                className={`${styles.link} ${pageActive.includes("/refund-transaction") && styles.active
                  } d-flex align-items-center gap-10 text-white`}
              >
                <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    viewBox="0 0 14 19"
                    fill="none"
                  >
                    <path
                      d="M4.03866 5.771C3.69219 5.771 3.41797 6.04521 3.41797 6.39169V7.6658C4.09377 7.79262 4.66011 8.41016 4.65995 9.18418C4.6598 9.95235 4.104 10.5706 3.41797 10.7074V11.9791C3.41797 12.3256 3.69219 12.6004 4.03866 12.6004H12.7289C13.0754 12.6004 13.3496 12.3256 13.3496 11.9791V10.7074C12.6636 10.5706 12.1078 9.95235 12.1076 9.18418C12.1075 8.41016 12.6738 7.79262 13.3496 7.6658V6.39169C13.3496 6.04521 13.0754 5.771 12.7289 5.771H4.03866ZM6.83176 6.39169C7.51368 6.39169 8.07375 6.95115 8.07375 7.63306C8.07375 8.31498 7.51368 8.87505 6.83176 8.87505C6.14984 8.87505 5.58978 8.31498 5.58978 7.63306C5.58978 6.95115 6.14984 6.39169 6.83176 6.39169ZM10.3589 6.90145C10.438 6.90145 10.5172 6.93161 10.5777 6.99177C10.698 7.11281 10.698 7.30836 10.5777 7.4294L6.6281 11.379C6.50679 11.5009 6.30935 11.5009 6.18804 11.379C6.06772 11.258 6.06772 11.0624 6.18804 10.9414L10.1401 6.99177C10.2006 6.93161 10.2798 6.90145 10.3589 6.90145ZM6.83176 7.01238C6.48529 7.01238 6.21107 7.28659 6.21107 7.63306C6.21107 7.97954 6.48529 8.25436 6.83176 8.25436C7.17823 8.25436 7.45245 7.97954 7.45245 7.63306C7.45245 7.28659 7.17823 7.01238 6.83176 7.01238ZM9.93582 9.49574C10.6177 9.49574 11.1778 10.0558 11.1778 10.7377C11.1778 11.4196 10.6177 11.9791 9.93582 11.9791C9.2539 11.9791 8.69444 11.4196 8.69444 10.7377C8.69444 10.0558 9.2539 9.49574 9.93582 9.49574ZM9.93582 10.117C9.58934 10.117 9.31513 10.3913 9.31513 10.7377C9.31513 11.0842 9.58934 11.3584 9.93582 11.3584C10.2823 11.3584 10.5571 11.0842 10.5571 10.7377C10.5571 10.3913 10.2823 10.117 9.93582 10.117Z"
                      fill="white"
                    />
                    <path
                      d="M1.48646 0.494629C0.968591 0.494629 0.556641 0.90961 0.556641 1.42748V17.5648C0.55664 18.0827 0.968591 18.4946 1.48646 18.4946H10.4877C11.0055 18.4946 11.4181 18.0827 11.4181 17.5648V13.2212C9.11846 13.2209 4.59052 13.2212 4.59052 13.2212C3.9086 13.2212 3.34914 12.6611 3.34914 11.9792V10.4263C3.34974 10.2548 3.48924 10.1165 3.6607 10.1171C4.17857 10.1171 4.59052 9.70216 4.59052 9.18428C4.59052 8.66641 4.17857 8.25446 3.6607 8.25446C3.48924 8.25512 3.34976 8.11678 3.34914 7.94533V6.39179C3.34914 5.70987 3.9086 5.1498 4.59052 5.1498H11.4181V1.42748C11.4181 0.909611 11.0055 0.494629 10.4877 0.494629H1.48646ZM5.80886 1.42748C5.8168 1.42728 5.82453 1.42748 5.8325 1.42748C6.34302 1.42748 6.76293 1.84678 6.76293 2.3573C6.76293 2.86782 6.34302 3.29016 5.8325 3.29016C5.32198 3.29016 4.90026 2.86782 4.90026 2.3573C4.90026 1.85476 5.30913 1.44031 5.80886 1.42748ZM5.8325 2.04817C5.65743 2.04817 5.52095 2.18223 5.52095 2.3573C5.52095 2.53238 5.65743 2.66886 5.8325 2.66886C6.00758 2.66886 6.14164 2.53238 6.14164 2.3573C6.14164 2.18223 6.00758 2.04817 5.8325 2.04817ZM5.21181 15.7021H6.4538C6.96432 15.7021 7.38362 16.1239 7.38362 16.6344C7.38362 17.1449 6.96432 17.5648 6.4538 17.5648H5.21181C4.70129 17.5648 4.27957 17.1449 4.27957 16.6344C4.27957 16.1239 4.70129 15.7021 5.21181 15.7021ZM5.21181 16.3228C5.03674 16.3228 4.90026 16.4593 4.90026 16.6344C4.90026 16.8095 5.03674 16.9435 5.21181 16.9435H6.4538C6.62887 16.9435 6.76293 16.8095 6.76293 16.6344C6.76293 16.4593 6.62887 16.3228 6.4538 16.3228H5.21181Z"
                      fill="white"
                    />
                  </svg>
                </span>
                Refund Transaction
              </NavLink>
            </li>

            <li className="py-1">
              <NavLink
                to="/manage-staff"
                className={`${styles.link} ${pageActive.includes("/manage-staff") && styles.active
                  } d-flex align-items-center gap-10 text-white`}
              >
                <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    viewBox="0 0 18 16"
                    fill="none"
                  >
                    <path
                      d="M10.8622 2.63264C11.6945 3.15447 12.2781 4.03751 12.3844 5.06252C12.7238 5.22111 13.1005 5.31231 13.4999 5.31231C14.958 5.31231 16.1398 4.13051 16.1398 2.67263C16.1398 1.21452 14.958 0.0327148 13.4999 0.0327148C12.0557 0.0331641 10.8842 1.19385 10.8622 2.63264ZM9.13276 8.03781C10.5909 8.03781 11.7727 6.85578 11.7727 5.3979C11.7727 3.94002 10.5906 2.75821 9.13276 2.75821C7.67488 2.75821 6.4924 3.94024 6.4924 5.39812C6.4924 6.856 7.67488 8.03781 9.13276 8.03781ZM10.2526 8.21774H8.0125C6.14871 8.21774 4.63242 9.73425 4.63242 11.598V14.3375L4.63939 14.3804L4.82808 14.4395C6.60674 14.9952 8.152 15.1805 9.42389 15.1805C11.9081 15.1805 13.348 14.4723 13.4368 14.4271L13.6131 14.3379H13.632V11.598C13.6326 9.73425 12.1164 8.21774 10.2526 8.21774ZM14.6201 5.49247H12.3974C12.3733 6.3818 11.9937 7.18262 11.3933 7.75859C13.0499 8.25121 14.2621 9.78749 14.2621 11.6021V12.4463C16.4568 12.3659 17.7215 11.7438 17.8048 11.7021L17.9811 11.6126H18V8.87233C18 7.00875 16.4837 5.49247 14.6201 5.49247ZM4.50056 5.31276C5.017 5.31276 5.49749 5.16203 5.90453 4.90527C6.03392 4.06132 6.48634 3.32384 7.13261 2.82156C7.13531 2.77214 7.14002 2.72317 7.14002 2.6733C7.14002 1.21519 5.95799 0.0333887 4.50056 0.0333887C3.04223 0.0333887 1.86065 1.21519 1.86065 2.6733C1.86065 4.13073 3.04223 5.31276 4.50056 5.31276ZM6.87136 7.75859C6.27383 7.18554 5.89555 6.38899 5.86791 5.50505C5.78547 5.49898 5.70393 5.49247 5.61992 5.49247H3.38008C1.51629 5.49247 0 7.00875 0 8.87233V11.6122L0.00696368 11.6544L0.195657 11.714C1.62254 12.1594 2.89599 12.3647 4.0021 12.4294V11.6021C4.00255 9.78749 5.21423 8.25166 6.87136 7.75859Z"
                      fill="white"
                    />
                  </svg>
                </span>
                Staff
              </NavLink>
            </li>

            <li className="py-1">
              <NavLink
                to="/blogs"
                className={`${styles.link} ${pageActive.includes("/blogs") && styles.active
                  } d-flex align-items-center gap-10 text-white`}
              >
                <TbLogs size={"1.5em"} />
                Blogs
              </NavLink>
            </li>

            <li className="py-1">
              <NavLink
                to="/contact-us"
                className={`${styles.link} ${pageActive.includes("/contact-us") && styles.active
                  } d-flex align-items-center gap-10 text-white`}
              >
                {/* <TbLogs size={"1.5em"} /> */}
                <TbMessageCircle size={"1.5em"} />
                Contact Us
              </NavLink>
            </li>

            <li className="py-1">
              <NavLink
                to="/content-pages"
                className={`${styles.link} ${pageActive.includes("/content-pages") && styles.active
                  } d-flex align-items-center gap-10 text-white`}
              >
                {/* <FaBookOpen /> */} <TbFileText size={"1.5em"} />
                Content Pages
              </NavLink>
            </li>

            <li className="py-1">
              <NavLink
                to="/email-template"
                className={`${styles.link} ${pageActive.includes("/email-template") && styles.active
                  } d-flex align-items-center gap-10 text-white`}
              >
                <FaBookOpen />
                Email Template
              </NavLink>
            </li>

            <li className="py-1">
              <NavLink
                to="/faq"
                className={`${styles.link} ${pageActive.includes("/faq") && styles.active
                  } d-flex align-items-center gap-10 text-white`}
              >
                <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    viewBox="0 0 19 17"
                    fill="none"
                  >
                    <path
                      d="M14.0645 0.683594H4.15039C1.9211 0.683594 0.107422 2.49727 0.107422 4.72656V8.59375C0.107422 10.6444 1.64192 12.3433 3.62305 12.6025V16.1814C3.62305 16.3947 3.75151 16.587 3.94859 16.6686C4.01381 16.6956 4.08236 16.7088 4.15029 16.7088C4.2875 16.7088 4.42239 16.6552 4.52326 16.5543L8.44086 12.6367H14.0645C16.2937 12.6367 18.1074 10.823 18.1074 8.59375V4.72656C18.1074 2.49727 16.2937 0.683594 14.0645 0.683594ZM5.77113 6.36375C5.98207 6.36375 6.1016 6.56766 6.1016 6.79266C6.1016 6.9825 6.00312 7.2075 5.77113 7.2075H4.70944V9.02157C4.70944 9.24657 4.43519 9.35907 4.16101 9.35907C3.88675 9.35907 3.61257 9.24657 3.61257 9.02157V4.55676C3.61257 4.33176 3.8516 4.21926 4.0907 4.21926H6.53047C6.7625 4.21926 6.86094 4.46535 6.86094 4.69035C6.86094 4.95051 6.74141 5.17551 6.53047 5.17551H4.70941V6.36375H5.77113ZM10.0813 9.35903C9.90554 9.35903 9.76491 9.30278 9.72276 9.15512L9.48366 8.27622H8.00011L7.76108 9.15512C7.71886 9.30278 7.57823 9.35903 7.40245 9.35903C7.10011 9.35903 6.69932 9.16919 6.69932 8.90903C6.69932 8.88794 6.70639 8.85981 6.71339 8.83169L8.02116 4.5427C8.09854 4.2966 8.41495 4.17707 8.73835 4.17707C9.06175 4.17707 9.37816 4.2966 9.45554 4.5427L10.7703 8.83169C10.7773 8.85981 10.7844 8.88794 10.7844 8.90903C10.7844 9.16919 10.3837 9.35903 10.0813 9.35903ZM14.9398 7.74184C14.9398 8.81059 14.3492 9.28165 13.5476 9.38013V9.78794C13.5476 10.0129 13.3789 10.1254 13.2101 10.1254C13.0414 10.1254 12.8726 10.0129 12.8726 9.78794V9.38013C12.0711 9.28169 11.4875 8.81059 11.4875 7.74184V5.8786C11.4875 4.66219 12.2398 4.21926 13.2101 4.21926C14.1804 4.21926 14.9398 4.66223 14.9398 5.8786L14.9398 7.74184Z"
                      fill="white"
                    />
                  </svg>
                </span>
                FAQs
              </NavLink>
            </li>

            <li className="py-1">
              <Accordion.Item
                className={`${styles.accordionWrp} border-0 bg-transparent`}
                eventKey="0"
              >
                <Accordion.Header
                  className={`${styles.accordionBtn} fw-bold d-flex align-items-center gap-10`}
                >
                  <span className={`${styles.icn} ${styles.fill} icn me-1`}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="15"
                      viewBox="0 0 18 19"
                      fill="none"
                    >
                      <path
                        d="M17.9432 8.60728C17.9148 8.35428 17.6197 8.16396 17.3645 8.16396C16.5399 8.16396 15.808 7.67993 15.501 6.93076C15.1877 6.16361 15.3899 5.26911 16.0043 4.70544C16.1978 4.5285 16.2214 4.23223 16.0592 4.02657C15.6369 3.49054 15.1573 3.00627 14.6334 2.58662C14.4284 2.42221 14.1272 2.4451 13.9494 2.64196C13.413 3.23607 12.4493 3.45683 11.7047 3.14616C10.9301 2.82023 10.4411 2.03502 10.4891 1.1922C10.505 0.927303 10.3113 0.697119 10.0473 0.666371C9.37497 0.588528 8.69672 0.58627 8.02244 0.661078C7.76182 0.68988 7.5683 0.914615 7.57694 1.17617C7.60613 2.01073 7.11167 2.78208 6.34452 3.09634C5.60882 3.39689 4.65189 3.17776 4.11656 2.58888C3.93962 2.39489 3.64374 2.37107 3.43737 2.53197C2.89807 2.95521 2.40758 3.43978 1.98146 3.97146C1.81542 4.17813 1.83994 4.47767 2.0351 4.65523C2.66166 5.22264 2.86367 6.12484 2.53836 6.90094C2.22776 7.64085 1.45952 8.11748 0.580123 8.11748C0.294749 8.1083 0.0916546 8.30003 0.0601279 8.55956C-0.0189612 9.23547 -0.0198175 9.92455 0.0563136 10.606C0.0847265 10.8601 0.38855 11.0488 0.646524 11.0488C1.43041 11.0288 2.18253 11.5138 2.4985 12.2819C2.81291 13.049 2.61052 13.9431 1.99509 14.5076C1.80258 14.6845 1.77798 14.9801 1.94052 15.1855C2.35846 15.7182 2.8386 16.2028 3.36404 16.626C3.57033 16.7921 3.87034 16.7689 4.04915 16.5718C4.58767 15.9763 5.55114 15.7559 6.29276 16.0672C7.06963 16.3923 7.55834 17.1774 7.51062 18.0204C7.49497 18.2853 7.68911 18.5162 7.95215 18.5463C8.29622 18.5865 8.64208 18.6064 8.98903 18.6064C9.3183 18.6064 9.64766 18.5885 9.97702 18.5518C10.2379 18.523 10.4312 18.298 10.4224 18.0364C10.3922 17.2022 10.8878 16.4308 11.654 16.1172C12.3946 15.8147 13.3473 16.036 13.8829 16.6241C14.0608 16.8177 14.3549 16.8412 14.5621 16.6809C15.1004 16.2588 15.59 15.7744 16.018 15.2413C16.1842 15.0351 16.1606 14.7351 15.9644 14.5573C15.3379 13.9902 15.1349 13.0876 15.4602 12.3123C15.7659 11.5824 16.5056 11.0923 17.3012 11.0923L17.4125 11.0952C17.6708 11.1162 17.9081 10.9173 17.9393 10.6538C18.0188 9.97725 18.0197 9.28895 17.9432 8.60728ZM8.99984 14.7951C6.13419 14.7951 3.81126 12.4721 3.81126 9.60655C3.81126 6.74098 6.13427 4.41804 8.99984 4.41804C11.8654 4.41804 14.1884 6.74098 14.1884 9.60655C14.1884 10.5792 13.9203 11.489 13.4545 12.2669L11.1826 9.99492C11.3471 9.6071 11.4339 9.18667 11.4339 8.75277C11.4339 7.9031 11.1029 7.10435 10.5021 6.50363C9.90135 5.90291 9.1026 5.57208 8.25309 5.57208C7.96958 5.57208 7.6874 5.60975 7.4144 5.68409C7.29484 5.71671 7.19706 5.81526 7.16523 5.93506C7.13269 6.05759 7.16935 6.18315 7.2651 6.27897C7.2651 6.27897 8.38675 7.40926 8.76203 7.78447C8.80134 7.82378 8.80127 7.91758 8.79574 7.95137L8.79224 7.97604C8.7544 8.38861 8.68146 8.88385 8.62129 9.07418C8.6132 9.0822 8.60557 9.08897 8.59732 9.09722C8.58868 9.10587 8.58074 9.11419 8.57241 9.12276C8.37959 9.18464 7.87672 9.25844 7.45761 9.29596L7.45769 9.2937L7.43885 9.29845C7.4355 9.29884 7.42927 9.29931 7.42102 9.29931C7.37572 9.29931 7.30908 9.28662 7.24852 9.22613C6.8579 8.83552 5.78023 7.76555 5.78023 7.76555C5.68355 7.66918 5.58438 7.64894 5.51829 7.64894C5.36424 7.64894 5.2263 7.76026 5.18286 7.91992C4.8862 9.01775 5.20069 10.1986 6.0038 11.0018C6.60467 11.6026 7.40351 11.9335 8.25317 11.9335C8.68707 11.9335 9.1075 11.8467 9.49524 11.6822L11.7919 13.9788C10.9856 14.4947 10.0281 14.7951 8.99984 14.7951Z"
                        fill="white"
                      />
                    </svg>
                  </span>
                  Settings
                </Accordion.Header>
                <Accordion.Body className="pb-0 pt-2 pe-0">
                  <ul className="list-unstyled ps-3 mb-0">
                    <li className="py-1">
                      <NavLink
                        to="/settings"
                        className={`${styles.link} ${pageActive.includes("/settings") && styles.active
                          } d-flex align-items-center gap-10 text-white`}
                      >
                        {/* <span
                        className={`${styles.icn} ${styles.stroke} icn me-1`}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="15"
                          height="15"
                          viewBox="0 0 18 18"
                          fill="none"
                        >
                          <path
                            d="M17.6004 6.49643L15.5357 5.98867C15.4116 5.59727 15.2519 5.21773 15.0593 4.85467C15.3693 4.33864 16.0208 3.25256 16.0208 3.25256C16.1454 3.04504 16.1125 2.77929 15.9415 2.60832L14.4501 1.11693C14.2791 0.945434 14.0139 0.912492 13.8059 1.03761L12.2012 1.9991C11.8401 1.80803 11.4627 1.64993 11.0739 1.52685L10.5661 -0.537844C10.5074 -0.772687 10.2967 -0.9375 10.0547 -0.9375H7.94531C7.70326 -0.9375 7.49211 -0.772688 7.43393 -0.537879C7.43393 -0.537879 7.08219 0.903176 6.92666 1.52632C6.5121 1.65763 6.11146 1.8281 5.72984 2.03616L4.06593 1.03761C3.85787 0.914004 3.59318 0.945961 3.42169 1.11693L1.93029 2.60832C1.75932 2.77929 1.72635 3.04504 1.85098 3.25256L2.87993 4.97107C2.7141 5.29809 2.57505 5.63848 2.46435 5.98712L0.399656 6.49643C0.164813 6.55514 0 6.76576 0 7.00781V9.11719C0 9.35924 0.164812 9.57039 0.399621 9.62857L2.46484 10.1363C2.59 10.5334 2.7527 10.9191 2.94996 11.2894L2.02918 12.824C1.90455 13.0316 1.93753 13.2973 2.1085 13.4683L3.59989 14.9597C3.77037 15.1301 4.03608 15.1625 4.24413 15.039C4.24413 15.039 5.27667 14.42 5.78239 14.1171C6.14855 14.3123 6.53168 14.4735 6.9267 14.5986L7.43396 16.6628C7.49211 16.8977 7.70326 17.0625 7.94531 17.0625H10.0547C10.2967 17.0625 10.5074 16.8977 10.5661 16.6629L11.0733 14.5987C11.4797 14.4699 11.871 14.3036 12.2434 14.1017C12.763 14.4133 13.8058 15.039 13.8058 15.039C14.0134 15.1631 14.2791 15.1312 14.4501 14.9597L15.9415 13.4683C16.1124 13.2973 16.1454 13.0316 16.0208 12.824L15.0727 11.2446C15.2596 10.8897 15.4146 10.5184 15.5357 10.1363L17.6003 9.62857C17.8352 9.56986 18 9.35924 18 9.11719V7.00781C18 6.76576 17.8352 6.55514 17.6004 6.49643ZM9 11.7539C6.96477 11.7539 5.30859 10.0977 5.30859 8.0625C5.30859 6.02727 6.96477 4.37109 9 4.37109C11.0352 4.37109 12.6914 6.02727 12.6914 8.0625C12.6914 10.0977 11.0352 11.7539 9 11.7539Z"
                            fill="white"
                          />
                        </svg>
                      </span> */}
                        General Settings
                      </NavLink>
                    </li>
                    <li className="py-1">
                      <NavLink
                        to="/home-page-content"
                        className={`${styles.link} ${pageActive.includes("/home-page-content") &&
                          styles.active
                          } d-flex align-items-center gap-10 text-white`}
                      >
                        {/* <span
                        className={`${styles.icn} ${styles.stroke} icn me-1`}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="15"
                          height="15"
                          viewBox="0 0 18 18"
                          fill="none"
                        >
                          <path
                            d="M17.6004 6.49643L15.5357 5.98867C15.4116 5.59727 15.2519 5.21773 15.0593 4.85467C15.3693 4.33864 16.0208 3.25256 16.0208 3.25256C16.1454 3.04504 16.1125 2.77929 15.9415 2.60832L14.4501 1.11693C14.2791 0.945434 14.0139 0.912492 13.8059 1.03761L12.2012 1.9991C11.8401 1.80803 11.4627 1.64993 11.0739 1.52685L10.5661 -0.537844C10.5074 -0.772687 10.2967 -0.9375 10.0547 -0.9375H7.94531C7.70326 -0.9375 7.49211 -0.772688 7.43393 -0.537879C7.43393 -0.537879 7.08219 0.903176 6.92666 1.52632C6.5121 1.65763 6.11146 1.8281 5.72984 2.03616L4.06593 1.03761C3.85787 0.914004 3.59318 0.945961 3.42169 1.11693L1.93029 2.60832C1.75932 2.77929 1.72635 3.04504 1.85098 3.25256L2.87993 4.97107C2.7141 5.29809 2.57505 5.63848 2.46435 5.98712L0.399656 6.49643C0.164813 6.55514 0 6.76576 0 7.00781V9.11719C0 9.35924 0.164812 9.57039 0.399621 9.62857L2.46484 10.1363C2.59 10.5334 2.7527 10.9191 2.94996 11.2894L2.02918 12.824C1.90455 13.0316 1.93753 13.2973 2.1085 13.4683L3.59989 14.9597C3.77037 15.1301 4.03608 15.1625 4.24413 15.039C4.24413 15.039 5.27667 14.42 5.78239 14.1171C6.14855 14.3123 6.53168 14.4735 6.9267 14.5986L7.43396 16.6628C7.49211 16.8977 7.70326 17.0625 7.94531 17.0625H10.0547C10.2967 17.0625 10.5074 16.8977 10.5661 16.6629L11.0733 14.5987C11.4797 14.4699 11.871 14.3036 12.2434 14.1017C12.763 14.4133 13.8058 15.039 13.8058 15.039C14.0134 15.1631 14.2791 15.1312 14.4501 14.9597L15.9415 13.4683C16.1124 13.2973 16.1454 13.0316 16.0208 12.824L15.0727 11.2446C15.2596 10.8897 15.4146 10.5184 15.5357 10.1363L17.6003 9.62857C17.8352 9.56986 18 9.35924 18 9.11719V7.00781C18 6.76576 17.8352 6.55514 17.6004 6.49643ZM9 11.7539C6.96477 11.7539 5.30859 10.0977 5.30859 8.0625C5.30859 6.02727 6.96477 4.37109 9 4.37109C11.0352 4.37109 12.6914 6.02727 12.6914 8.0625C12.6914 10.0977 11.0352 11.7539 9 11.7539Z"
                            fill="white"
                          />
                        </svg>
                      </span> */}
                        Home Page Contents
                      </NavLink>
                    </li>

                    <li className="py-1">
                      <NavLink
                        to="/contact-us-content"
                        className={`${styles.link} ${pageActive.includes("/contact-us-content") &&
                          styles.active
                          } d-flex align-items-center gap-10 text-white`}
                      >
                        Contact Us Page Content
                      </NavLink>
                    </li>

                    <li className="py-1">
                      <NavLink
                        to="/faq-page-content"
                        className={`${styles.link} ${pageActive.includes("/faq-page-content") &&
                          styles.active
                          } d-flex align-items-center gap-10 text-white`}
                      >
                        FAQ Page Content
                      </NavLink>
                    </li>

                    <li className="py-1">
                      <NavLink
                        to="/partnership-and-affiliates"
                        className={`${styles.link} ${pageActive.includes("/partnership-and-affiliates") &&
                          styles.active
                          } d-flex align-items-center gap-10 text-white`}
                      >
                        Partnership & Affiliates
                      </NavLink>
                    </li>

                    <li className="py-1">
                      <NavLink
                        to="/about-and-sustainability"
                        className={`${styles.link} ${pageActive.includes("/about-and-sustainability") &&
                          styles.active
                          } d-flex align-items-center gap-10 text-white`}
                      >
                        About & Sustainability Page Content
                      </NavLink>
                    </li>
                    <li className="py-1">
                      <NavLink
                        to="/change-password"
                        className={`${styles.link} ${pageActive.includes("/change-password") &&
                          styles.active
                          } d-flex align-items-center gap-10 text-white`}
                      >
                        Change Password
                      </NavLink>
                    </li>
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
            </li>

            {/* <li className="py-1">
              <NavLink
                to="/manage-category"
                className={`${styles.link} ${pageActive.includes("/manage-category") && styles.active
                  } d-flex align-items-center gap-10 text-white`}
              >
                <FaBookOpen />
                Category
              </NavLink>
            </li> */}

            {/* <li className="py-1">
              <NavLink
                to="/meal-package-management"
                className={`${styles.link} ${pageActive.includes("/meal-package-management") &&
                  styles.active
                  } d-flex align-items-center gap-10 text-white`}
              >
                <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                  <GiMeal size="1.5em" />
                </span>
                Meal Packages
              </NavLink>
            </li> */}

            {/* <li className="py-1">
              <NavLink
                to="/diet-type"
                className={`${styles.link} ${pageActive.includes("/diet-type") && styles.active
                  } d-flex align-items-center gap-10 text-white`}
              >
                <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                  <GiMeal size="1.5em" />
                </span>
                Diet Type
              </NavLink>
            </li> */}

            {/* <li className="py-1">
              <NavLink
                to="/ingredient-management"
                className={`${styles.link} ${pageActive.includes("/ingredient-management") && styles.active
                  } d-flex align-items-center gap-10 text-white`}
              >
                <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                  <MdFoodBank size="1.5em" />
                </span>
                Ingredients
              </NavLink>
            </li> */}

            {/* <li className="py-1">
              <NavLink
                to="/equipment"
                className={`${styles.link} ${pageActive.includes("/equipment") && styles.active
                  } d-flex align-items-center gap-10 text-white`}
              >
                <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                  <MdFoodBank size="1.5em" />
                </span>
                Equipments
              </NavLink>
            </li> */}

            {/* <li className="py-1">
              <NavLink
                to="/recipes"
                className={`${styles.link} ${pageActive.includes("/recipes") && styles.active
                  } d-flex align-items-center gap-10 text-white`}
              >
                <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                  <PiBowlFoodFill size={"1.5em"} />
                </span>
                Recipes
              </NavLink>
            </li> */}

            {/* <li className="py-1">
              <NavLink
                to="/order-management"
                className={`${styles.link} ${pageActive.includes("/order-management") && styles.active
                  } d-flex align-items-center gap-10 text-white`}
              >
                <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    viewBox="0 0 14 19"
                    fill="none"
                  >
                    <path
                      d="M11.8296 2.45337H10.5341C10.8814 4.10155 9.55988 5.7127 7.87407 5.69377H5.61377C3.92796 5.71277 2.60644 4.10141 2.95376 2.45337H1.6582C0.744143 2.45337 0.000488281 3.19702 0.000488281 4.11108V16.5429C0.000488281 17.4691 0.752795 18.2006 1.6582 18.2006H11.8296C12.7559 18.2006 13.4874 17.4483 13.4874 16.5429V4.11112C13.4874 3.19702 12.7437 2.45337 11.8296 2.45337ZM5.13918 12.8853L4.00903 14.0155C3.80303 14.2215 3.46894 14.2215 3.26295 14.0155L2.69789 13.4504C2.49186 13.2444 2.49186 12.9104 2.69789 12.7043C2.90389 12.4983 3.23794 12.4983 3.44397 12.7043L3.636 12.8963L4.39313 12.1392C4.59912 11.9332 4.93318 11.9332 5.13921 12.1392C5.34521 12.3453 5.34521 12.6793 5.13918 12.8853ZM5.13918 10.0599L4.00903 11.1901C3.81256 11.3944 3.45938 11.3944 3.26291 11.1901L2.69785 10.625C2.49186 10.419 2.49186 10.0849 2.69785 9.87891C2.90389 9.67291 3.2379 9.67291 3.44393 9.87891L3.63593 10.0709L4.39302 9.31381C4.90778 8.83855 5.61423 9.5458 5.13918 10.0599ZM5.13918 7.23451L4.00903 8.36466C3.81256 8.56903 3.45938 8.569 3.26295 8.36466L2.69789 7.79956C2.49189 7.59353 2.49189 7.25951 2.69789 7.05348C2.90392 6.84749 3.23794 6.84749 3.44397 7.05348L3.63597 7.24552L4.39309 6.48843C4.59909 6.2824 4.93314 6.2824 5.13918 6.48843C5.34521 6.69446 5.34521 7.02848 5.13918 7.23451ZM9.56934 16.4303H7.27152C6.57155 16.4024 6.57207 15.4028 7.27152 15.3752H9.56934C10.2693 15.4031 10.2688 16.4027 9.56934 16.4303ZM10.6995 13.6049H7.27148C6.57151 13.577 6.57204 12.5774 7.27148 12.5498H10.6995C11.3995 12.5777 11.3989 13.5773 10.6995 13.6049ZM6.74392 10.252C6.74392 9.96061 6.98013 9.7244 7.27148 9.7244H9.56931C10.2693 9.75229 10.2688 10.7519 9.56931 10.7795H7.27148C6.98013 10.7795 6.74392 10.5433 6.74392 10.252ZM10.6995 7.95411H7.27148C6.57151 7.92622 6.57204 6.92659 7.27148 6.89898H10.6995C11.3995 6.92687 11.3989 7.9265 10.6995 7.95411Z"
                      fill="white"
                    />
                    <path
                      d="M5.61377 4.6388H7.8741C9.79978 4.59153 10.152 1.956 8.33614 1.38886C7.86429 -0.195341 5.62288 -0.195412 5.15169 1.38886C3.33465 1.95687 3.68956 4.59209 5.61377 4.6388Z"
                      fill="white"
                    />
                  </svg>
                </span>
                Order Management
              </NavLink>
            </li> */}

            {/* 
          <li className="py-1">
            <NavLink
              to="/manage-service-category"
              className={`${styles.link} ${
                pageActive.includes("/manage-service-category") && styles.active
              } d-flex align-items-center gap-10 text-white`}
            >
              <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  viewBox="0 0 18 19"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.2322 18.5707H7.13207C6.64701 18.5707 6.25685 18.1805 6.25685 17.6849V15.597C5.67689 15.3651 5.1391 15.0593 4.65404 14.6902L2.85088 15.713C2.408 15.9767 1.93348 15.8185 1.65931 15.4072L0.0986815 12.7183C-0.112215 12.2965 0.0248678 11.7904 0.415026 11.5478L2.23928 10.5039C2.16547 9.76576 2.16547 9.36505 2.23928 8.63746L0.415026 7.59353C0.0248678 7.35099 -0.112215 6.84484 0.0986815 6.41251L1.64877 3.73412C1.69095 3.56541 2.24982 3.05926 2.85088 3.41778L4.6435 4.45117C5.11801 4.09265 5.64525 3.78685 6.25685 3.51268V1.4459C6.25685 0.960837 6.63647 0.570679 7.13207 0.570679H10.2217C10.7068 0.570679 11.0653 0.950292 11.0653 1.4459V3.51268C11.6874 3.7763 12.2358 4.0821 12.7103 4.45117L14.5134 3.41778C14.9563 3.15416 15.4308 3.31233 15.705 3.73412L17.2551 6.41251C17.4554 6.81321 17.3289 7.31936 16.9598 7.58298L15.104 8.62692C15.2094 9.23852 15.2094 9.8923 15.104 10.5039L16.9598 11.5478C17.3289 11.8115 17.4554 12.3176 17.2551 12.7183L15.705 15.3967C15.6628 15.5654 15.1145 16.0716 14.5134 15.713L12.7103 14.6796C12.2147 15.0593 11.6663 15.3651 11.0653 15.597V17.6849C11.0758 18.1911 10.7068 18.5707 10.2322 18.5707ZM3.83155 9.56541C3.83155 6.87648 6.00378 4.71479 8.68216 4.71479C11.3711 4.71479 13.5328 6.88702 13.5328 9.56541C13.5328 15.9767 3.83155 15.9028 3.83155 9.56541Z"
                    fill="white"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M11.392 9.85007C11.392 10.778 10.9386 11.6321 10.2005 12.1172V13.8466C9.18818 14.1524 8.07043 14.1418 7.06867 13.8044V12.0328C5.36041 10.8096 5.64512 8.19453 7.58537 7.3404C7.77517 7.26659 7.97553 7.39312 7.97553 7.60402V9.56536H9.38853V7.60402C9.38853 7.39312 9.59943 7.25604 9.78923 7.35094C10.7594 7.79383 11.392 8.77449 11.392 9.85007Z"
                    fill="white"
                  />
                </svg>
              </span>
              Manage Service Category
            </NavLink>
          </li>
          <li className="py-1">
            <NavLink
              to="/manage-commissions"
              className={`${styles.link} ${
                pageActive.includes("/manage-commissions") && styles.active
              } d-flex align-items-center gap-10 text-white`}
            >
              <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  viewBox="0 0 20 21"
                  fill="none"
                >
                  <path
                    d="M12.9297 0.873535C10.3445 0.873535 8.24219 3.01545 8.24219 5.6001C8.24219 8.18475 10.3445 10.2876 12.9297 10.2876C15.5149 10.2876 17.6172 8.18475 17.6172 5.6001C17.6172 3.01545 15.5149 0.873535 12.9297 0.873535ZM11.7578 3.25635C12.0814 3.25635 12.3438 3.51861 12.3438 3.84229C12.3438 4.16588 12.0814 4.42822 11.7578 4.42822C11.4342 4.42822 11.1719 4.16588 11.1719 3.84229C11.1719 3.51861 11.4343 3.25635 11.7578 3.25635ZM14.1016 7.94385C13.778 7.94385 13.5156 7.6815 13.5156 7.35791C13.5156 7.03424 13.778 6.77197 14.1016 6.77197C14.4252 6.77197 14.6875 7.03424 14.6875 7.35791C14.6875 7.6815 14.4252 7.94385 14.1016 7.94385ZM14.5891 4.16729L12.2454 7.68291C12.0638 7.95436 11.6999 8.02346 11.4328 7.84541C11.1639 7.66572 11.0906 7.3024 11.2703 7.03287L13.6141 3.51725C13.7949 3.24717 14.1588 3.17623 14.4266 3.35475C14.6955 3.53443 14.7688 3.89779 14.5891 4.16729Z"
                    fill="white"
                  />
                  <path
                    d="M0.171621 15.7327C-0.057207 15.9616 -0.057207 16.3325 0.171621 16.5613L4.27318 20.7019C4.50205 20.9308 4.87287 20.9308 5.10174 20.7019L5.93049 19.8731C6.15936 19.6443 6.15936 19.2733 5.93049 19.0444L1.82908 14.9039C1.60021 14.675 1.22928 14.675 1.00037 14.9039L0.171621 15.7327Z"
                    fill="white"
                  />
                  <path
                    d="M15.3638 17.1977L19.8168 13.0433C20.058 12.814 20.0599 12.4338 19.8282 12.2033C19.8241 12.1991 19.82 12.195 19.8158 12.191C19.1746 11.5589 18.0791 11.6201 17.4036 12.2153L14.8801 14.4875C14.5734 14.7937 14.1339 14.975 13.667 14.975H9.99988C9.67602 14.975 9.41395 14.713 9.41395 14.3891C9.41395 14.0652 9.67602 13.8032 9.99988 13.8032H13.5155C14.1627 13.8032 14.6874 13.2784 14.6874 12.6313C14.6874 11.9841 14.1627 11.4594 13.5155 11.4594H11.1054C9.84652 10.0558 7.41453 9.94309 6.0332 11.246L2.84082 14.2591L6.58734 18.0441L7.27375 17.3579H14.9611C15.1108 17.3579 15.255 17.3005 15.3638 17.1977Z"
                    fill="white"
                  />
                </svg>
              </span>
              Manage Commissions
            </NavLink>
          </li>
          <li className="py-1">
            <NavLink
              to="/earnings"
              className={`${styles.link} ${
                pageActive.includes("/earnings") && styles.active
              } d-flex align-items-center gap-10 text-white`}
            >
              <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  viewBox="0 0 18 19"
                  fill="none"
                >
                  <path
                    d="M1.72266 10.7959C2.70316 11.2526 3.98918 11.5043 5.34375 11.5043C5.74137 11.5043 6.13301 11.4825 6.51199 11.44C7.03828 9.63224 8.34328 8.15251 10.0375 7.38927C9.76149 7.11575 9.39621 6.86895 8.94902 6.65872C8.6727 6.52864 8.37141 6.41509 8.05078 6.31946V7.35587C8.05078 8.2281 7.34098 8.9379 6.46875 8.9379H4.21875C3.34652 8.9379 2.63672 8.2281 2.63672 7.35587V6.31665C2.31047 6.41298 2.00391 6.52688 1.72266 6.65802C0.611719 7.17552 0 7.91028 0 8.72696C0 9.54364 0.611719 10.2784 1.72266 10.7959Z"
                    fill="white"
                  />
                  <path
                    d="M1.72266 13.6084C2.70316 14.0654 3.98918 14.3168 5.34375 14.3168C5.68266 14.3168 6.01699 14.301 6.34289 14.2704C6.28699 13.9308 6.25781 13.5824 6.25781 13.227C6.25781 12.9879 6.27082 12.752 6.29684 12.52C5.98395 12.546 5.66508 12.559 5.34375 12.559C3.83836 12.559 2.39414 12.2725 1.27723 11.7521C0.775547 11.5184 0.347695 11.242 0 10.9277V11.5395C0 12.3561 0.611719 13.0909 1.72266 13.6084Z"
                    fill="white"
                  />
                  <path
                    d="M5.34375 15.3715C3.83836 15.3715 2.39449 15.085 1.27723 14.5646C0.775547 14.3309 0.347695 14.0545 0 13.7402V14.352C0 15.1686 0.611719 15.9034 1.72266 16.4209C2.70316 16.8779 3.98918 17.1293 5.34375 17.1293C6.07324 17.1293 6.78164 17.0562 7.43168 16.917C7.08363 16.4255 6.80273 15.883 6.60375 15.3029C6.19312 15.3483 5.7709 15.3715 5.34375 15.3715Z"
                    fill="white"
                  />
                  <path
                    d="M12.6562 7.8833C9.7098 7.8833 7.3125 10.2806 7.3125 13.2271C7.3125 16.1735 9.7098 18.5708 12.6562 18.5708C15.6027 18.5708 18 16.1735 18 13.2271C18 10.2806 15.6027 7.8833 12.6562 7.8833ZM14.1936 14.2969C14.0977 14.8681 13.7015 15.322 13.182 15.5092C13.1653 15.7854 12.9366 16.0044 12.6562 16.0044C12.3967 16.0044 12.1814 15.8167 12.1376 15.5697C11.8913 15.5278 11.6673 15.4369 11.3836 15.2513C11.14 15.0917 11.0714 14.7651 11.231 14.5212C11.3903 14.2775 11.7172 14.2093 11.9609 14.3686C12.2179 14.537 12.3005 14.5496 12.6527 14.5475C12.992 14.5454 13.127 14.2789 13.1534 14.1221C13.1773 13.9812 13.1505 13.7938 12.8893 13.7013C12.4513 13.5466 12.0023 13.3691 11.6842 13.1195C11.346 12.854 11.1902 12.3988 11.2785 11.9315C11.3691 11.4512 11.6943 11.0648 12.1341 10.9071C12.1684 10.649 12.3888 10.4497 12.6562 10.4497C12.9424 10.4497 13.1748 10.6777 13.1828 10.9619C13.2975 11.0042 13.4072 11.0539 13.5083 11.1065C13.8123 11.2648 13.8826 11.6687 13.6504 11.9207C13.4866 12.0984 13.2214 12.1414 13.0118 12.0211C12.8474 11.9267 12.6527 11.8497 12.5012 11.8954C12.361 11.9376 12.323 12.0835 12.3149 12.127C12.2977 12.2181 12.3223 12.2793 12.3353 12.2895C12.5343 12.4456 12.9045 12.5883 13.2406 12.7068C13.9296 12.9504 14.3125 13.5895 14.1936 14.2969Z"
                    fill="white"
                  />
                  <path
                    d="M2.8125 5.03564H3.69141V7.35596C3.69141 7.64705 3.92766 7.8833 4.21875 7.8833H6.46875C6.75985 7.8833 6.9961 7.64705 6.9961 7.35596V5.03564H7.875C8.07434 5.03564 8.25645 4.9235 8.3461 4.74525C8.43575 4.56736 8.41711 4.35396 8.29828 4.194L5.76703 0.783848C5.66754 0.649902 5.51075 0.570801 5.34375 0.570801C5.17676 0.570801 5.01996 0.649902 4.92047 0.783848L2.38922 4.194C2.27039 4.35396 2.25176 4.56736 2.34141 4.74525C2.43106 4.9235 2.61317 5.03564 2.8125 5.03564Z"
                    fill="white"
                  />
                </svg>
              </span>
              Earnings
            </NavLink>
          </li>
          <li className="py-1">
            <NavLink
              to="/accounting"
              className={`${styles.link} ${
                pageActive.includes("/accounting") && styles.active
              } d-flex align-items-center gap-10 text-white`}
            >
              <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  viewBox="0 0 19 18"
                  fill="none"
                >
                  <path
                    d="M6.68028 13.2107C6.46169 13.1399 6.30741 12.9406 6.30741 12.6899C6.30741 12.4456 6.46813 12.2335 6.69311 12.1628C6.75099 11.5649 6.886 10.9992 7.08528 10.4592C7.01454 10.4913 6.94383 10.5042 6.86669 10.5042C6.55814 10.5042 6.30741 10.2535 6.30741 9.95136C6.30741 9.63637 6.55814 9.39208 6.86669 9.39208C7.11742 9.39208 7.32314 9.55279 7.39384 9.77778C8.46097 7.74636 10.576 6.35134 13.0124 6.35134C13.231 6.35134 13.4431 6.36421 13.6553 6.38351V2.83493C13.6553 1.42707 12.511 0.276367 11.0967 0.276367H2.63668C1.22883 0.276367 0.078125 1.42707 0.078125 2.83493V13.5256C0.078125 14.9399 1.22883 16.0906 2.63668 16.0906H7.59956C7.08528 15.2421 6.75742 14.2649 6.68028 13.2171V13.2107ZM3.74885 4.95635H9.99097C10.3445 4.95635 10.6338 5.23921 10.6338 5.5992C10.6338 5.95277 10.3445 6.24206 9.99097 6.24206H3.74885C3.38885 6.24206 3.106 5.95277 3.106 5.5992C3.106 5.23921 3.38885 4.95635 3.74885 4.95635ZM3.74885 13.2492C3.44026 13.2492 3.18957 12.9985 3.18957 12.6899C3.18957 12.3813 3.44026 12.1307 3.74885 12.1307C4.05098 12.1307 4.30814 12.3813 4.30814 12.6899C4.30814 12.9985 4.05098 13.2492 3.74885 13.2492ZM3.74885 10.5042C3.44026 10.5042 3.18957 10.2535 3.18957 9.95136C3.18957 9.63637 3.44026 9.39208 3.74885 9.39208C4.05741 9.39208 4.30814 9.63637 4.30814 9.95136C4.30814 10.2535 4.05741 10.5042 3.74885 10.5042Z"
                    fill="white"
                  />
                  <path
                    d="M13.0124 7.63721C10.2224 7.63721 7.95312 9.93221 7.95312 12.7544C7.95312 15.5701 10.2224 17.8651 13.0124 17.8651C15.8088 17.8651 18.0781 15.5701 18.0781 12.7544C18.0781 9.93221 15.8088 7.63721 13.0124 7.63721ZM13.0124 12.1115C13.996 12.1115 14.7996 12.9215 14.7996 13.9179C14.7996 14.6958 14.311 15.3515 13.636 15.6087C13.5846 15.9108 13.3338 16.1487 13.0124 16.1487C12.6974 16.1487 12.4467 15.9108 12.3953 15.6087C11.7138 15.3515 11.2317 14.6958 11.2317 13.9179C11.2317 13.5644 11.521 13.2751 11.8745 13.2751C12.2281 13.2751 12.5174 13.5644 12.5174 13.9179C12.5174 14.2072 12.7424 14.4451 13.0124 14.4451C13.2888 14.4451 13.5139 14.2072 13.5139 13.9179C13.5139 13.6286 13.2888 13.3972 13.0124 13.3972C12.0289 13.3972 11.2317 12.5808 11.2317 11.5844C11.2317 10.8065 11.7138 10.1508 12.3953 9.89364C12.4467 9.59152 12.6974 9.3601 13.0124 9.3601C13.3338 9.3601 13.5846 9.59152 13.636 9.89364C14.311 10.1508 14.7996 10.8065 14.7996 11.5844C14.7996 11.9379 14.5103 12.2272 14.1567 12.2272C13.7967 12.2272 13.5139 11.9379 13.5139 11.5844C13.5139 11.2951 13.2888 11.0636 13.0124 11.0636C12.7424 11.0636 12.5174 11.2951 12.5174 11.5844C12.5174 11.8737 12.7424 12.1115 13.0124 12.1115Z"
                    fill="white"
                  />
                </svg>
              </span>
              Accounting
            </NavLink>
          </li>
          <li className="py-1">
            <NavLink
              to="/help"
              className={`${styles.link} ${
                pageActive.includes("/help") && styles.active
              } d-flex align-items-center gap-10 text-white`}
            >
              <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  viewBox="0 0 19 19"
                  fill="none"
                >
                  <path
                    d="M9.70508 0.11084C4.73079 0.11084 0.705078 4.13609 0.705078 9.11084C0.705078 14.0851 4.73033 18.1108 9.70508 18.1108C14.6794 18.1108 18.7051 14.0856 18.7051 9.11084C18.7051 4.13655 14.6798 0.11084 9.70508 0.11084ZM9.43877 13.3232C8.92936 13.3232 8.53842 12.8967 8.53842 12.411C8.53842 11.9134 8.9412 11.4988 9.43877 11.4988C9.93637 11.4988 10.3509 11.9135 10.3509 12.411C10.3509 12.8967 9.94815 13.3232 9.43877 13.3232ZM10.7893 8.71484C10.1377 9.22425 10.1258 9.57965 10.1258 10.1957C10.1258 10.4208 10.0074 10.6814 9.42689 10.6814C8.94113 10.6814 8.77534 10.5037 8.77534 9.88769C8.77534 8.86886 9.22551 8.38314 9.56906 8.08698C9.96 7.75525 10.6234 7.38804 10.6234 6.74834C10.6234 6.20335 10.1496 5.94273 9.55721 5.94273C8.34886 5.94273 8.6095 6.85497 7.96973 6.85497C7.64988 6.85497 7.25894 6.64168 7.25894 6.17969C7.25894 5.53998 7.99343 4.59221 9.59275 4.59221C11.1091 4.59221 12.1161 5.43336 12.1161 6.54693C12.1161 7.6605 11.1091 8.46607 10.7893 8.71484Z"
                    fill="white"
                  />
                </svg>
              </span>
              Help
            </NavLink>
          </li>
          <li className="py-1">
            <NavLink
              to="/system-access"
              className={`${styles.link} ${
                pageActive.includes("/system-access") && styles.active
              } d-flex align-items-center gap-10 text-white`}
            >
              <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  viewBox="0 0 18 17"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M5.2679 14.585L4.46093 15.9697C4.44793 15.9918 4.44102 16.0171 4.44091 16.0428C4.4408 16.0685 4.44749 16.0938 4.4603 16.1161C4.47311 16.1384 4.49159 16.1569 4.51386 16.1697C4.53613 16.1826 4.5614 16.1893 4.58712 16.1892H13.4129C13.4386 16.1893 13.4639 16.1826 13.4861 16.1697C13.5084 16.1569 13.5269 16.1384 13.5397 16.1161C13.5525 16.0938 13.5592 16.0685 13.5591 16.0428C13.559 16.0171 13.5521 15.9918 13.5391 15.9697L12.7322 14.5849L5.2679 14.585ZM12.4618 8.08263C12.6712 8.08263 12.8759 8.14473 13.05 8.26107C13.2241 8.37742 13.3599 8.54278 13.44 8.73626C13.5201 8.92973 13.5411 9.14263 13.5002 9.34802C13.4594 9.55341 13.3585 9.74207 13.2105 9.89015C13.0624 10.0382 12.8737 10.1391 12.6683 10.1799C12.4629 10.2208 12.25 10.1998 12.0566 10.1197C11.8631 10.0395 11.6977 9.90383 11.5814 9.7297C11.465 9.55558 11.4029 9.35087 11.4029 9.14145C11.4029 8.86064 11.5145 8.59132 11.7131 8.39275C11.9116 8.19418 12.181 8.08263 12.4618 8.08263ZM14.6556 2.78935C14.9152 2.78935 15.169 2.86633 15.3848 3.01056C15.6007 3.15479 15.7689 3.35978 15.8682 3.59963C15.9676 3.83947 15.9936 4.10338 15.9429 4.358C15.8923 4.61261 15.7673 4.84649 15.5837 5.03006C15.4001 5.21363 15.1663 5.33864 14.9116 5.38928C14.657 5.43993 14.3931 5.41394 14.1533 5.31459C13.9134 5.21524 13.7084 5.04701 13.5642 4.83116C13.42 4.6153 13.343 4.36153 13.343 4.10193C13.343 3.75381 13.4813 3.41995 13.7274 3.1738C13.9736 2.92764 14.3075 2.78935 14.6556 2.78935ZM5.57562 4.3425C5.12545 4.34249 4.68539 4.47598 4.31109 4.72607C3.93679 4.97617 3.64505 5.33164 3.47278 5.74754C3.3005 6.16344 3.25542 6.62108 3.34325 7.0626C3.43107 7.50412 3.64784 7.90968 3.96616 8.22799C4.28447 8.54631 4.69003 8.76308 5.13155 8.8509C5.57307 8.93873 6.03071 8.89365 6.44661 8.72137C6.86251 8.5491 7.21798 8.25736 7.46808 7.88306C7.71817 7.50876 7.85166 7.0687 7.85165 6.61853C7.85165 6.01489 7.61186 5.43597 7.18502 5.00913C6.75818 4.58229 6.17926 4.3425 5.57562 4.3425ZM6.93602 6.07623L5.45477 7.57155C5.4007 7.62592 5.32736 7.65677 5.25068 7.6574C5.17401 7.65803 5.10017 7.62838 5.04522 7.5749L4.21879 6.76947C4.16353 6.71558 4.13193 6.64196 4.13091 6.56478C4.12989 6.4876 4.15954 6.41317 4.21336 6.35784C4.26718 6.30251 4.34075 6.2708 4.41793 6.26968C4.49511 6.26856 4.56957 6.29811 4.62498 6.35185L5.24468 6.95593L6.52316 5.66548C6.55008 5.63814 6.58214 5.61639 6.61749 5.60148C6.65284 5.58657 6.69079 5.57879 6.72916 5.57859C6.76753 5.57838 6.80556 5.58577 6.84107 5.60031C6.87657 5.61485 6.90886 5.63626 6.93606 5.66332C6.96327 5.69038 6.98486 5.72254 6.99959 5.75797C7.01433 5.7934 7.02192 5.83138 7.02193 5.86975C7.02194 5.90812 7.01437 5.94612 6.99965 5.98155C6.98494 6.01698 6.96336 6.04916 6.93617 6.07623H6.93602ZM17.0603 0.80957H0.939688C0.690689 0.810293 0.452095 0.909527 0.276026 1.0856C0.099957 1.26167 0.000722451 1.50026 0 1.74926V12.4275H18V1.74926C17.9993 1.50026 17.9 1.26167 17.724 1.0856C17.5479 0.909527 17.3093 0.810293 17.0603 0.80957ZM9.95265 7.34894H9.21969C9.12488 7.82391 8.93765 8.27562 8.66862 8.67838L9.18708 9.19684L8.15415 10.2301L7.63569 9.71165C7.23289 9.98071 6.78113 10.168 6.3061 10.2627V10.9957H4.84521V10.2626C4.37018 10.1678 3.91841 9.98065 3.51559 9.71165L2.99713 10.2301L1.9643 9.19706L2.48276 8.6786C2.2136 8.2758 2.02628 7.82401 1.93144 7.34894H1.19862V5.88809H1.93144C2.02628 5.41304 2.21361 4.96127 2.48276 4.5585L1.9643 4.04004L2.99727 3.00707L3.51573 3.52553C3.91853 3.25647 4.37029 3.06923 4.84532 2.97446V2.24146H6.30617V2.97446C6.7812 3.06921 7.23295 3.25645 7.63572 3.52553L8.15418 3.00707L9.18712 4.04004L8.66866 4.5585C8.93772 4.96128 9.12496 5.41303 9.21972 5.88805H9.95272L9.95265 7.34894ZM14.7626 9.52544H14.3773C14.3275 9.77513 14.2291 10.0126 14.0876 10.2243L14.3602 10.4969L13.8172 11.0399L13.5447 10.7673C13.3329 10.9088 13.0955 11.0072 12.8458 11.057V11.4423H12.0779V11.057C11.8282 11.0072 11.5907 10.9087 11.379 10.7673L11.1064 11.0399L10.5634 10.4969L10.836 10.2243C10.6945 10.0126 10.5961 9.77512 10.5463 9.5254H10.1611V8.7575H10.5463C10.5961 8.5078 10.6946 8.27033 10.836 8.0586L10.5634 7.78605L11.1064 7.24305L11.379 7.51561C11.5907 7.37419 11.8282 7.27577 12.0779 7.22597V6.84067H12.8458V7.22597C13.0955 7.27579 13.333 7.37421 13.5447 7.51561L13.8172 7.24305L14.3602 7.78605L14.0876 8.0586C14.229 8.27033 14.3275 8.5078 14.3773 8.7575H14.7626V9.52544ZM17.1799 4.52316H16.7572C16.7026 4.79708 16.5947 5.0576 16.4396 5.28989L16.7386 5.58892L16.1427 6.18467L15.8437 5.88564C15.6114 6.04074 15.3509 6.14867 15.077 6.20329V6.62609H14.2345V6.2034C13.9606 6.14879 13.7001 6.04086 13.4678 5.88575L13.1688 6.18478L12.5731 5.58906L12.8721 5.29007C12.717 5.05778 12.6091 4.79726 12.5545 4.52334H12.1316V3.68066H12.5543C12.6088 3.40673 12.7168 3.14621 12.8719 2.91393L12.5729 2.61486L13.1686 2.01918L13.4676 2.31821C13.6999 2.16309 13.9604 2.05516 14.2343 2.00056V1.57769H15.0768V2.00049C15.3507 2.05511 15.6112 2.16304 15.8435 2.31814L16.1425 2.01911L16.7382 2.61483L16.4392 2.91385C16.5943 3.14615 16.7022 3.40667 16.7568 3.68059H17.1795L17.1799 4.52316ZM18 13.0116V13.0612C17.9993 13.3102 17.9 13.5488 17.724 13.7249C17.5479 13.9009 17.3093 14.0002 17.0603 14.0009H0.939688C0.690689 14.0002 0.452095 13.9009 0.276026 13.7249C0.099957 13.5488 0.000722451 13.3102 0 13.0612V13.0116H18Z"
                    fill="white"
                  />
                </svg>
              </span>
              System Access
            </NavLink>
          </li>
          <li className="py-1">
            <NavLink
              to="/content-page"
              className={`${styles.link} ${
                pageActive.includes("/content-page") && styles.active
              } d-flex align-items-center gap-10 text-white`}
            >
              <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  viewBox="0 0 19 16"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M12.188 12.3451L9.99946 13.1215C9.8505 13.1743 9.68478 13.1369 9.57323 13.0254C9.46167 12.9138 9.42427 12.7481 9.47715 12.5991L10.2535 10.4106C10.258 10.3983 10.2645 10.3874 10.2742 10.3783L16.0641 4.58775C16.3498 4.30209 16.8134 4.30209 17.0991 4.58775L18.0109 5.49954C18.2965 5.7852 18.2965 6.24884 18.0109 6.5345L12.2203 12.3244C12.2112 12.3341 12.2003 12.3406 12.188 12.3451ZM14.4114 11.9575V13.9907C14.4114 14.504 14.2076 14.996 13.8446 15.3584C13.4822 15.7214 12.9902 15.9252 12.4769 15.9252H2.15959C1.64631 15.9252 1.1543 15.7214 0.791905 15.3584C0.428864 14.996 0.225098 14.504 0.225098 13.9907V4.96304H13.8652L9.36172 9.46655C9.21728 9.61099 9.10637 9.78638 9.03802 9.97983L8.26164 12.1677C8.0424 12.7855 8.19844 13.4735 8.66143 13.9372C9.12507 14.4002 9.8131 14.5562 10.4309 14.337L12.6188 13.5606C12.8122 13.4922 14.4114 11.9575 14.4114 11.9575ZM3.44926 12.701H5.49273C5.84868 12.701 6.13756 12.4121 6.13756 12.0562C6.13756 11.7002 5.84868 11.4114 5.49273 11.4114H3.44926C3.09331 11.4114 2.80443 11.7002 2.80443 12.0562C2.80443 12.4121 3.09331 12.701 3.44926 12.701ZM3.44926 10.1217H6.78239C7.13834 10.1217 7.42723 9.83281 7.42723 9.47687C7.42723 9.12092 7.13834 8.83203 6.78239 8.83203H3.44926C3.09331 8.83203 2.80443 9.12092 2.80443 9.47687C2.80443 9.83281 3.09331 10.1217 3.44926 10.1217ZM3.44926 7.54237H9.36172C9.71767 7.54237 10.0066 7.25348 10.0066 6.89754C10.0066 6.54159 9.71767 6.25271 9.36172 6.25271H3.44926C3.09331 6.25271 2.80443 6.54159 2.80443 6.89754C2.80443 7.25348 3.09331 7.54237 3.44926 7.54237ZM0.225098 3.67338V2.38371C0.225098 1.87043 0.428864 1.37842 0.791905 1.01603C1.1543 0.652986 1.64631 0.449219 2.15959 0.449219H12.4769C12.9902 0.449219 13.4822 0.652986 13.8446 1.01603C14.2076 1.37842 14.4114 1.87043 14.4114 2.38371V3.67338H0.225098Z"
                    fill="white"
                  />
                </svg>
              </span>
              Content Page Management
            </NavLink>
          </li> */}
          </ul>
        )}

        {user?.role == "Staff" && (
          <ul className="list-unstyled ps-0 mb-0">
            {/* <li className="py-1">
              <NavLink
                to="/order-management"
                className={`${styles.link} ${pageActive.includes("/order-management") && styles.active
                  } d-flex align-items-center gap-10 text-white`}
              >
                <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    viewBox="0 0 14 19"
                    fill="none"
                  >
                    <path
                      d="M11.8296 2.45337H10.5341C10.8814 4.10155 9.55988 5.7127 7.87407 5.69377H5.61377C3.92796 5.71277 2.60644 4.10141 2.95376 2.45337H1.6582C0.744143 2.45337 0.000488281 3.19702 0.000488281 4.11108V16.5429C0.000488281 17.4691 0.752795 18.2006 1.6582 18.2006H11.8296C12.7559 18.2006 13.4874 17.4483 13.4874 16.5429V4.11112C13.4874 3.19702 12.7437 2.45337 11.8296 2.45337ZM5.13918 12.8853L4.00903 14.0155C3.80303 14.2215 3.46894 14.2215 3.26295 14.0155L2.69789 13.4504C2.49186 13.2444 2.49186 12.9104 2.69789 12.7043C2.90389 12.4983 3.23794 12.4983 3.44397 12.7043L3.636 12.8963L4.39313 12.1392C4.59912 11.9332 4.93318 11.9332 5.13921 12.1392C5.34521 12.3453 5.34521 12.6793 5.13918 12.8853ZM5.13918 10.0599L4.00903 11.1901C3.81256 11.3944 3.45938 11.3944 3.26291 11.1901L2.69785 10.625C2.49186 10.419 2.49186 10.0849 2.69785 9.87891C2.90389 9.67291 3.2379 9.67291 3.44393 9.87891L3.63593 10.0709L4.39302 9.31381C4.90778 8.83855 5.61423 9.5458 5.13918 10.0599ZM5.13918 7.23451L4.00903 8.36466C3.81256 8.56903 3.45938 8.569 3.26295 8.36466L2.69789 7.79956C2.49189 7.59353 2.49189 7.25951 2.69789 7.05348C2.90392 6.84749 3.23794 6.84749 3.44397 7.05348L3.63597 7.24552L4.39309 6.48843C4.59909 6.2824 4.93314 6.2824 5.13918 6.48843C5.34521 6.69446 5.34521 7.02848 5.13918 7.23451ZM9.56934 16.4303H7.27152C6.57155 16.4024 6.57207 15.4028 7.27152 15.3752H9.56934C10.2693 15.4031 10.2688 16.4027 9.56934 16.4303ZM10.6995 13.6049H7.27148C6.57151 13.577 6.57204 12.5774 7.27148 12.5498H10.6995C11.3995 12.5777 11.3989 13.5773 10.6995 13.6049ZM6.74392 10.252C6.74392 9.96061 6.98013 9.7244 7.27148 9.7244H9.56931C10.2693 9.75229 10.2688 10.7519 9.56931 10.7795H7.27148C6.98013 10.7795 6.74392 10.5433 6.74392 10.252ZM10.6995 7.95411H7.27148C6.57151 7.92622 6.57204 6.92659 7.27148 6.89898H10.6995C11.3995 6.92687 11.3989 7.9265 10.6995 7.95411Z"
                      fill="white"
                    />
                    <path
                      d="M5.61377 4.6388H7.8741C9.79978 4.59153 10.152 1.956 8.33614 1.38886C7.86429 -0.195341 5.62288 -0.195412 5.15169 1.38886C3.33465 1.95687 3.68956 4.59209 5.61377 4.6388Z"
                      fill="white"
                    />
                  </svg>
                </span>
                Order Management staff
              </NavLink>
            </li> */}
            <li className="py-1">
              <NavLink
                to="/orders"
                className={`${styles.link} ${pageActive == ("/orders") && styles.active
                  } d-flex align-items-center gap-10 text-white`}
              >
                <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    viewBox="0 0 14 19"
                    fill="none"
                  >
                    <path
                      d="M4.03866 5.771C3.69219 5.771 3.41797 6.04521 3.41797 6.39169V7.6658C4.09377 7.79262 4.66011 8.41016 4.65995 9.18418C4.6598 9.95235 4.104 10.5706 3.41797 10.7074V11.9791C3.41797 12.3256 3.69219 12.6004 4.03866 12.6004H12.7289C13.0754 12.6004 13.3496 12.3256 13.3496 11.9791V10.7074C12.6636 10.5706 12.1078 9.95235 12.1076 9.18418C12.1075 8.41016 12.6738 7.79262 13.3496 7.6658V6.39169C13.3496 6.04521 13.0754 5.771 12.7289 5.771H4.03866ZM6.83176 6.39169C7.51368 6.39169 8.07375 6.95115 8.07375 7.63306C8.07375 8.31498 7.51368 8.87505 6.83176 8.87505C6.14984 8.87505 5.58978 8.31498 5.58978 7.63306C5.58978 6.95115 6.14984 6.39169 6.83176 6.39169ZM10.3589 6.90145C10.438 6.90145 10.5172 6.93161 10.5777 6.99177C10.698 7.11281 10.698 7.30836 10.5777 7.4294L6.6281 11.379C6.50679 11.5009 6.30935 11.5009 6.18804 11.379C6.06772 11.258 6.06772 11.0624 6.18804 10.9414L10.1401 6.99177C10.2006 6.93161 10.2798 6.90145 10.3589 6.90145ZM6.83176 7.01238C6.48529 7.01238 6.21107 7.28659 6.21107 7.63306C6.21107 7.97954 6.48529 8.25436 6.83176 8.25436C7.17823 8.25436 7.45245 7.97954 7.45245 7.63306C7.45245 7.28659 7.17823 7.01238 6.83176 7.01238ZM9.93582 9.49574C10.6177 9.49574 11.1778 10.0558 11.1778 10.7377C11.1778 11.4196 10.6177 11.9791 9.93582 11.9791C9.2539 11.9791 8.69444 11.4196 8.69444 10.7377C8.69444 10.0558 9.2539 9.49574 9.93582 9.49574ZM9.93582 10.117C9.58934 10.117 9.31513 10.3913 9.31513 10.7377C9.31513 11.0842 9.58934 11.3584 9.93582 11.3584C10.2823 11.3584 10.5571 11.0842 10.5571 10.7377C10.5571 10.3913 10.2823 10.117 9.93582 10.117Z"
                      fill="white"
                    />
                    <path
                      d="M1.48646 0.494629C0.968591 0.494629 0.556641 0.90961 0.556641 1.42748V17.5648C0.55664 18.0827 0.968591 18.4946 1.48646 18.4946H10.4877C11.0055 18.4946 11.4181 18.0827 11.4181 17.5648V13.2212C9.11846 13.2209 4.59052 13.2212 4.59052 13.2212C3.9086 13.2212 3.34914 12.6611 3.34914 11.9792V10.4263C3.34974 10.2548 3.48924 10.1165 3.6607 10.1171C4.17857 10.1171 4.59052 9.70216 4.59052 9.18428C4.59052 8.66641 4.17857 8.25446 3.6607 8.25446C3.48924 8.25512 3.34976 8.11678 3.34914 7.94533V6.39179C3.34914 5.70987 3.9086 5.1498 4.59052 5.1498H11.4181V1.42748C11.4181 0.909611 11.0055 0.494629 10.4877 0.494629H1.48646ZM5.80886 1.42748C5.8168 1.42728 5.82453 1.42748 5.8325 1.42748C6.34302 1.42748 6.76293 1.84678 6.76293 2.3573C6.76293 2.86782 6.34302 3.29016 5.8325 3.29016C5.32198 3.29016 4.90026 2.86782 4.90026 2.3573C4.90026 1.85476 5.30913 1.44031 5.80886 1.42748ZM5.8325 2.04817C5.65743 2.04817 5.52095 2.18223 5.52095 2.3573C5.52095 2.53238 5.65743 2.66886 5.8325 2.66886C6.00758 2.66886 6.14164 2.53238 6.14164 2.3573C6.14164 2.18223 6.00758 2.04817 5.8325 2.04817ZM5.21181 15.7021H6.4538C6.96432 15.7021 7.38362 16.1239 7.38362 16.6344C7.38362 17.1449 6.96432 17.5648 6.4538 17.5648H5.21181C4.70129 17.5648 4.27957 17.1449 4.27957 16.6344C4.27957 16.1239 4.70129 15.7021 5.21181 15.7021ZM5.21181 16.3228C5.03674 16.3228 4.90026 16.4593 4.90026 16.6344C4.90026 16.8095 5.03674 16.9435 5.21181 16.9435H6.4538C6.62887 16.9435 6.76293 16.8095 6.76293 16.6344C6.76293 16.4593 6.62887 16.3228 6.4538 16.3228H5.21181Z"
                      fill="white"
                    />
                  </svg>
                </span>
                Orders Management Today
              </NavLink>
            </li>
            {/* <li>
              <h1>Test</h1>
            </li> */}

            <li className="py-1">
              <NavLink
                to="/store-order-management-today"
                className={`${styles.link} ${pageActive === "/store-order-management-today" &&
                  styles.active
                  } d-flex align-items-center gap-10 text-white`}
              >
                <span className={`${styles.icn} ${styles.stroke} icn me-1`}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <circle
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="white"
                      strokeWidth="2"
                    />
                    <path
                      d="M12 6v6l4 2"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                Store Order Management Today
              </NavLink>
            </li>
          </ul>
        )}
      </Accordion>
    </div>
  );
};

export default Sidebar;
